import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import { CardImg } from 'reactstrap';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const CardImage = ({ image, alt, imageLoading }) => (
	<div className="image-frame-background-black">
		<ProgressiveImage
			src={`${config.cdnUrl}/static/images/beneficiary/${image}`}
			placeholder={`${
				config.cdnUrl
			}/static/images/beneficiaries/${imageLoading}`}
		>
			{(src, loading) => (
				<CardImg
					className="image-landscape"
					top
					width="100%"
					style={{ opacity: loading ? 1 : 1 }}
					src={src}
					alt={alt}
				/>
			)}
		</ProgressiveImage>
	</div>
);

export default CardImage;
